import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
import { useFormElement } from '../../composables/useFormElement';
import { makeUseFormElementEmits, makeUseFormElementProps } from '../../composables/useFormElementInterfaces';
import { FieldModel } from '../../interfaces';
import { useBaseFieldValues } from '../../composables/useBaseFieldValues';
import { useTextFormFieldMethods } from '../../composables/useTextFormFieldMethods';


export default /*#__PURE__*/_defineComponent({
  __name: 'TextAreaFormField',
  props: makeUseFormElementProps<FieldModel, string>(),
  emits: makeUseFormElementEmits<string>(),
  setup(__props, { emit }) {

const props = __props;





const formElement = useFormElement<FieldModel, string>({
  emit,
  props,
});

const {
  maxLength,
  inputName,
  fieldType,
  readonly,
  autocomplete,
  placeholder,
  inputClass,
  inputErrorClass,
  fieldErrorsShown,
  valueToInputFn,
  emptyValue,
} = useBaseFieldValues(formElement);

const { onKeyPress, setValue } = useTextFormFieldMethods(formElement);

const { field, modelStateRef } = formElement;

const stringVal = computed(() => valueToInputFn.value(field.value.$model));

const showMaxLengthCounter = modelStateRef('showMaxLengthCounter', false);

const rows = modelStateRef('rows', 3);

function onInput(event: Event) {
  const text = (event.target as HTMLTextAreaElement).value || '';
  if (text.replace(/\s/g, '') === '') {
    setValue(emptyValue.value);
  } else {
    setValue(text);
  }
}

return { __sfc: true,props, emit, formElement, maxLength, inputName, fieldType, readonly, autocomplete, placeholder, inputClass, inputErrorClass, fieldErrorsShown, valueToInputFn, emptyValue, onKeyPress, setValue, field, modelStateRef, stringVal, showMaxLengthCounter, rows, onInput }
}

})